// Move this to context hook so it is globally available along with the user data

let accessToken = "";
export const setAccessToken = token => (accessToken = token);
export const getAccessToken = () => accessToken;
let resetToken = "";
export const setResetToken = token => (resetToken = token);
export const getResetToken = () => resetToken;
